import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Input from './Input'

interface Props {
  autoComplete?: string
  autoFocus?: boolean
  invalid?: boolean
  name?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  bgColor?: string
}

export default function PasswordInput({
  autoComplete,
  autoFocus = false,
  invalid = false,
  name,
  onChange,
  bgColor,
}: Props) {
  const [hidePassword, setHidePassword] = useState(true)

  const { t } = useTranslation()

  return (
    <div className="relative">
      <Input
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        invalid={invalid}
        name={name}
        onChange={onChange}
        placeholder={t('shared.password')}
        type={hidePassword ? 'password' : 'text'}
        dataTestId="textfield-password"
        bgColor={bgColor}
      />

      <button
        className="absolute inset-y-0 right-0 flex items-center pr-5"
        onClick={() => setHidePassword(!hidePassword)}
        type="button"
      >
        {hidePassword ? (
          <EyeSlashIcon className="text-custom-gray h-6 w-6" />
        ) : (
          <EyeIcon className="text-custom-gray h-6 w-6" />
        )}
      </button>
    </div>
  )
}
